import { request } from "umi";
import { paramsSerializer } from "../api";

const urlPrefix = "/api/google";

/**
 * Get Google Key
 *
 * POST api/google/get_google_maps_key
 */
export async function getGoogleMapKey() {
    return request<Record<string, any>>(`${urlPrefix}/get_google_maps_key`, {
        method: "GET",        
        withToken: true,
        paramsSerializer,               
    }).then((res) => (res));
}

